// extracted by mini-css-extract-plugin
export var imgWrapper = "assurance-module--img-wrapper--1RP9w";
export var icon = "assurance-module--icon--2mkt6";
export var imgContext = "assurance-module--img-context--1S8DJ";